import { module } from 'modujs'

export default class extends module {
  constructor(m) {
    super(m)

    this.bgInfos = this.el.querySelector('.o-solution_backgroundInfos')
    this.specDefaultBg = this.el.querySelector('.o-spec_cover .-default')

    this.onSequenceSolution = this.onSequenceSolution.bind(this)
    this.onSequenceBg = this.onSequenceBg.bind(this)
    this.onSpecProgress = this.onSpecProgress.bind(this)

    window.addEventListener('sequence-solution', this.onSequenceSolution)

    window.addEventListener('sequence-bg', this.onSequenceBg)

    window.addEventListener('specProgress', this.onSpecProgress)

    this.events = { click: { activeSpec: 'activeSpec' } }
  }

  onSequenceBg(e) {
    const { progress } = e.detail

    this.bgInfos.style.opacity = 1 - progress
  }

  onSpecProgress(e) {
    const { progress } = e.detail

    this.specDefaultBg.style.opacity = 1 - progress
  }

  activeSpec(e) {
    const specCategory = e.currentTarget.getAttribute('data-category')

    if (this.el.querySelector('.o-spec_list li.-active')) {
      this.el.querySelector('.o-spec_list li.-active').classList.remove('-active')
    }
    if (this.el.querySelector('.o-spec_content.-active')) {
      this.el.querySelector('.o-spec_content.-active').classList.remove('-active')
    }

    e.currentTarget.classList.add('-active')
    this.el.querySelector(`.o-spec_content[data-category="${specCategory}"]`).classList.add('-active')
  }

  onSequenceSolution(e) {
    const {
      target,
      progress
    } = e.detail
    const start = Number.parseInt(target.getAttribute('data-start'))
    const end = Number.parseInt(target.getAttribute('data-end'))
    const max = Number.parseInt(target.getAttribute('data-max'))

    const sectionTotalProgress = (end - start) / max
    const sectionStartProgress = start / max

    if (progress > 0) {
      const sectionProgress = sectionStartProgress + (progress * sectionTotalProgress)

      this.call(
        'setProgress',
        sectionProgress,
        'ImagesSequence',
        'sequence-solution'
      )
    }
  }

  destroy() {
    window.removeEventListener('sequence-solution', this.onSequenceSolution)
    window.removeEventListener('sequence-bg', this.onSequenceBg)
    window.removeEventListener('specProgress', this.onSpecProgress)
  }
}
